/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_ConcretingRequest } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, {
  TNonEmptyArray,
  TConcretingRequestType
} from "@graphql/helpers/utils.graphql";

type TConcretingRequestCreateFunctions = {
  create: CommandResult_ConcretingRequest;
};
export type TConcretingRequestCreateMutations = {
  concretingRequest: TConcretingRequestCreateFunctions;
};
export const concretingRequestCreate = (
  fields: TNonEmptyArray<TConcretingRequestType>
) => gql`
  mutation concretingRequestCreate($concretingRequest: ConcretingRequestCreateInputType!) {
    concretingRequest {
      create(concretingRequest: $concretingRequest) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequest")}
`;

type TConcretingRequestUpdateFunctions = {
  update: CommandResult_ConcretingRequest;
};

export type TConcretingRequestUpdateMutations = {
  concretingRequest: TConcretingRequestUpdateFunctions;
};
export const concretingRequestUpdate = (
  fields: TNonEmptyArray<TConcretingRequestType>
) => gql`
  mutation concretingRequestUpdate($concretingRequest: ConcretingRequestUpdateInputType!) {
    concretingRequest {
      update(concretingRequest: $concretingRequest) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequest")}
`;

type TConcretingRequestUpdateStatusFunctions = {
  concretingRequestUpdateStatus: CommandResult_ConcretingRequest;
};
export type TConcretingRequestUpdateStatusMutations = {
  concretingRequest: TConcretingRequestUpdateStatusFunctions;
};
export const concretingRequestUpdateStatus = (
  fields: TNonEmptyArray<TConcretingRequestType>
) => gql`
  mutation concretingRequestUpdateStatus (
    $concretingRequestStatus: ConcretingRequestUpdateStatusInputType!
  ) {
    concretingRequest {
      concretingRequestUpdateStatus(concretingRequestStatus: $concretingRequestStatus) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequest")}
`;
